<template>
  <Sidenav v-if="showSidenav" :custom-class="color" :class="[isTransparent, 'fixed-start']" />
  <main class="main-content position-relative max-height-vh-300 h-300 border-radius-lg">
    <!-- nav -->
    <navbar v-if="showNavbar" :class="[isNavFixed ? navbarFixed : '', isAbsolute ? absolute : '']"
      :text-white="isAbsolute ? 'text-white opacity-8' : ''" :min-nav="navbarMinimize" />
    <router-view />
    <Footer v-show="showFooter" class="mt-2" />
  </main>
  <!-- <Configurator /> NEW -->
</template>

<script>

  // IMPORTS
  import { mapState, mapMutations } from "vuex";



  import Footer from "./picko/layout/Footer.vue";
  import Navbar from "./picko/layout/Navbars/Navbar.vue";
  import Sidenav from "./picko/layout/sidenav/Sidenav.vue";



  //import Sidenav from "@/layout/Sidenav";
  //import Footer from "@/layout/Footer.vue";

  
  //import Navbar from "@/layout/Navbars/Navbar.vue";
  //import Configurator from "./examples/Configurator2.vue"; // TODO: Eliminar esta configuración global y usar las locales de cada componente

  export default {
    name: "App",
    components: {
      Footer,
      Navbar,
      Sidenav,      
      //Configurator
    },
    
    computed: {
      ...mapState([
        "isTransparent",
        "isNavFixed",
        "isAbsolute",
        "navbarFixed",
        "absolute",
        "color",
        "showSidenav",
        "showNavbar",
        "showFooter",
        "showConfig",
        "hideConfigButton",
      ]),
    },
    /* beforeMount() {
      this.$store.state.isTransparent = "bg-transparent";
    }, */
    methods: {
      ...mapMutations(["toggleConfigurator", "navbarMinimize"]),
    },
  };

</script>
